import { createApp } from 'vue';
import OpusToAacConverter from '@/Components/OpusToAacConverter.vue';
import '@styles/app.css';

createApp(OpusToAacConverter).mount('#opus-to-aac-converter');
